export const categories = [
  {
    id: "drama",
    name: "影视剧集",
    icon: "ri-clapperboard-line",
    count: 42,
    desc: "番位、路透、开机杀青与播出反馈，按剧集脉络整理。",
  },
  {
    id: "variety",
    name: "综艺前线",
    icon: "ri-tv-2-line",
    count: 28,
    desc: "剪辑争议、嘉宾阵容与节目改版，看综艺背后的叙事逻辑。",
  },
  {
    id: "music",
    name: "音乐现场",
    icon: "ri-mic-line",
    count: 31,
    desc: "巡演排期、票务规则与现场体验，音乐现场的完整链条。",
  },
  {
    id: "brand",
    name: "品牌联名",
    icon: "ri-shopping-bag-3-line",
    count: 19,
    desc: "限定周边、代言变动与营销翻车，商业合作的风险盘点。",
  },
  {
    id: "star",
    name: "明星动态",
    icon: "ri-user-star-line",
    count: 37,
    desc: "活动行程、社交动态与颁奖礼细节，轻量但信息密集。",
  },
  {
    id: "short",
    name: "短剧出海",
    icon: "ri-smartphone-line",
    count: 14,
    desc: "竖屏短剧的分账模式、题材本地化与投流成本观察。",
  },
];